var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('section',{staticClass:"u-mt-md"},[_c('AppTitle',{staticClass:"u-mb-0",attrs:{"title":_vm.$t('mantra')}})],1),_c('section',{staticClass:"u-mt-md"},[_c('Query',{staticClass:"grid is-tablet-4",attrs:{"query":require('~/graphql/Career.gql').Careers,"limit":10,"initialValue":_vm.careers,"variables":function (ref) {
	var first = ref.first;
	var after = ref.after;

	return ({ first: first, after: after, isPublished: true,isArchived: true });
}},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var items = ref.items;
return [_c('AsymetricGrid',{ref:"grid",attrs:{"items":items},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var item = ref.item;
var ratio = ref.ratio;
return [_c('AppCard',{attrs:{"img":item.thumb ? [{ srcset: item.thumb, type: 'image/jpg', ratio: ratio }] : [{ srcset: '{CDN_URL}/default@2x.jpg 2x, {CDN_URL}/default.jpg 1x', type: 'image/jpg' }],"ratio":ratio,"title":item.title,"excerpt":item.description,"url":("/careers/" + (item.slug))}})]}}],null,true)})]}}])})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }